/**
 * SiteConfigContext - 全局站点配置状态管理
 * 提供注册开关、维护模式、版权、ICP 等公开配置
 */
import React, { createContext, useContext, useState, useEffect } from 'react';

const API_BASE_URL = import.meta.env.VITE_API_URL || '/api';

interface SiteConfig {
  allowRegister: boolean;
  maintenanceMode: boolean;
  showCopyright: boolean;
  icpRecord: string;
}

interface SiteConfigContextType extends SiteConfig {
  loading: boolean;
}

const defaultConfig: SiteConfig = {
  allowRegister: true,
  maintenanceMode: false,
  showCopyright: true,
  icpRecord: '',
};

const SiteConfigContext = createContext<SiteConfigContextType>({
  ...defaultConfig,
  loading: true,
});

export function SiteConfigProvider({ children }: { children: React.ReactNode }) {
  const [config, setConfig] = useState<SiteConfig>(defaultConfig);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_BASE_URL}/config/site`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success && data.data) {
          setConfig({
            allowRegister: data.data.allowRegister !== false,
            maintenanceMode: data.data.maintenanceMode === true,
            showCopyright: data.data.showCopyright !== false,
            icpRecord: data.data.icpRecord || '',
          });
        }
      })
      .catch((err) => {
        console.error('获取站点配置失败:', err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <SiteConfigContext.Provider value={{ ...config, loading }}>
      {children}
    </SiteConfigContext.Provider>
  );
}

export function useSiteConfig() {
  return useContext(SiteConfigContext);
}
